import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/** POST `/crm/sales-order/{id}/return-to-draft`。PREPARING → DRAFT。body：`updatedAt`。 */
export async function returnSalesOrderToDraft(id, payload = {}) {
  const { data: raw } = await request.post(
    `/crm/sales-order/${id}/return-to-draft`,
    keysToSnake(payload),
  );
  return parseVer4DetailResponse(raw);
}
